// How long a quiz informational screen holds its loading animation before
// revealing content — gated on `quote-policy-quiz-response-animation`
// (flags.ts). A pure lookup so the variant → delay mapping is testable
// without mounting the screen or touching PostHog.

import type { QuizResponseAnimationVariant } from "../flags";

export const RESPONSE_REVEAL_DELAY_MS = 2000;

export function responseRevealDelayMs(
  variant: QuizResponseAnimationVariant,
): number {
  return variant === "test" ? 0 : RESPONSE_REVEAL_DELAY_MS;
}
